import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios'

import GlobalFooter from "../components/GlobalFooter";
import CustomerSidebar from "../components/CustomerSidebar";
import PlanCardList from '../components/Plan/PlanCardList';
import Features from '../components/Plan/Features';
import RecurlyPaymentForm from '../components/RecurlyPaymentForm';
import { Tag, Modal, Alert } from 'antd';
import StripeEmbeddedCheckout from '../components/StripeEmbeddedCheckout';

const NewPlans = ({}) => {

  const [plans, setPlans] = useState([])
  const [viewablePlans, setViewablePlans] = useState([])
  const [isMonthly, setIsMonthly] = useState(false)
  const [isShowingFeatures, setIsShowingFeatures] = useState(false) 
  const [isHiddenOrCustomPlan, setIsHiddenOrCustomPlan] = useState(false)
  const [clientSecret, setClientSecret] = useState(null);

  const [updateSubscriptionLoading, setUpdateSubscriptionLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPlan, setCurrentPlan] = useState(null)
  const [recurlyOptions, setRecurlyOptions] = useState({
    targetPlan: null,
    currentPlan: null,
    purpose: null
  })

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    getPlans();
  }, [])

  const handleSelectPlan = async (plan) => {
    if(currentPlan.planCode === 'free' && plan.planCode !== 'free') {
      // handleStripeClientSecret(plan.planCode);
      handleRecurlyModal({
        targetPlan: plan,
        currentPlan,
        purpose: 'checkout'
      })
      return;
    } 
    else if (plan.isCurrent) {
      // handleStripeClientSecret(plan.planCode);
      handleRecurlyModal({
        targetPlan: plan,
        currentPlan,
        purpose: 'change-payment-method'
      })
      return;
    }
    //upgrade, downgrade or cancel
    else {
      // handleUpdateStripeSubscription(plan.planCode);
      handleRecurlyModal({
        targetPlan: plan,
        currentPlan,
        purpose: 'update'
      })
    }
  };

  const fetchClientSecret = useCallback((planCode) => {
    return axios.post("/v1/checkout/web-subscription", {
      planCode: planCode
    })
    .then((data) => {
      return data.data.data.clientSecret;
    });
  }, []);

  const handleStripeClientSecret = async (planCode) => {
    try {
      fetchClientSecret(planCode).then((clientSecret) => {

        if(clientSecret) {
          showModal();
          setClientSecret(clientSecret);
        }
        
      }).catch((error) => {
        console.error("Error fetching client secret:", error);
      });

    } catch(e) {
      console.log(e)
    }
  }
      
  const handleUpdateStripeSubscription = async (planCode) => {

    try {
      setUpdateSubscriptionLoading(true);
  
      await axios.put('/v1/subscriptions', {
        planCode
      }) 

      setTimeout(() => {
        setUpdateSubscriptionLoading(false);
        window.location.reload();
      }, 2500)

      return;
    } catch(e) {
      setUpdateSubscriptionLoading(false);
    } 
  }

  const handleRecurlyModal = (options) => {
    setRecurlyOptions({
      ...options,
    })

    showModal();
  };

  const getPlans = async () => {
    const response = await axios.get('/v1/plans')

    const free = response.data.data.find(plan => plan.planCode === 'free')
    const goldMonth = response.data.data.find(plan => plan.planCode === 'gold')
    const goldyear = response.data.data.find(plan => plan.planCode === 'goldyear')
    const platinumMonth = response.data.data.find(plan => plan.planCode === 'platinum')
    const platinumyear = response.data.data.find(plan => plan.planCode === 'platinumyear')

    const isPlanMonthly = response.data.data.some(plan => plan.isCurrent && !(plan.planCode.includes('year')))
    const currentPlan = response.data.data.find(plan => plan.isCurrent)
    const isPlanHiddenOrCustom = response.data.data.some(plan => plan.isCurrent && ['hidden', 'custom'].includes(plan.type))

    setPlans({
      free, 
      gold: {
        month: goldMonth,
        year: goldyear
      },
      platinum: {
        month: platinumMonth,
        year: platinumyear
      }
    })

    if(isPlanMonthly) {
      setViewablePlans([
        free, 
        goldMonth, 
        platinumMonth
      ])
    } else {
      setViewablePlans([
        free, 
        goldyear, 
        platinumyear
      ])
    }

    setCurrentPlan(currentPlan)
    setIsMonthly(isPlanMonthly);
    setIsShowingFeatures(true);
    setIsHiddenOrCustomPlan(isPlanHiddenOrCustom);
  }

  const handleToggleBillingCycle = () => {
    setIsMonthly(!isMonthly)

    if(isMonthly) {
      setViewablePlans([plans.free, plans.gold.year, plans.platinum.year])
    } else {
      setViewablePlans([plans.free, plans.gold.month, plans.platinum.month])
    }
  }

  const handleToggleFeatureList = () => {
    setIsShowingFeatures(!isShowingFeatures)
  }

  return (
    <>
      <Modal title="Subscribe" visible={isModalOpen} onCancel={handleCancel} footer={null}>
        <div>
          <RecurlyPaymentForm
            options={recurlyOptions}
            getPlans={getPlans}
          />
          {/* <StripeEmbeddedCheckout clientSecret={clientSecret} /> */}
        </div>
      </Modal>
      <div className="body">
        <CustomerSidebar />
        <div className="content-area">
          <div className="plans-wrapper" style={{ width: "100%" }}>
            <div className="page-title"><h2>Membership Plans</h2></div>
            <Alert 
              showIcon
              message={`Any plan downgrades will take effect at the end of your current billing cycle. ${currentPlan?.billing.end ? `Your current billing cycle ends on ${new Date(currentPlan.billing.end).toLocaleDateString('en-CA')}.` : ``}`} 
              type="info" 
              style={{ margin: '0px 15px 10px' }} 
            />
            {
              isHiddenOrCustomPlan && (
                <Alert 
                  message={`You are currently on a custom plan. Please contact support for any changes.`} 
                  type="warning" 
                  style={{ margin: '0px 15px 10px' }} 
                />
              )
            }
            <div style={{
              display: 'flex',
              justifyContent: 'center',
            }}>
              <div className="btn-toggle">
                <button
                  className={`ddpEnable btn ${isMonthly ? 'btn-selected' : ''}`}
                  disabled={false}
                  onClick={handleToggleBillingCycle}
                >
                  Monthly
                </button>
                <button
                  className={`ddpDisable btn ${!isMonthly ? 'btn-selected' : ''}`}
                  disabled={false}
                  onClick={handleToggleBillingCycle}
                >
                  Yearly <Tag style={{ borderRadius: 10, margin: '0px 5px' }} color="blue">Save 2 Months</Tag>
                </button>
              </div>
            </div>
            <div style={{ 
              padding: 15,
              display: 'flex',
              justifyContent: 'center',
            }}>
            <PlanCardList 
              plans={viewablePlans}
              handleSelectPlan={handleSelectPlan}
              updateSubscriptionLoading={updateSubscriptionLoading}
              isHiddenOrCustomPlan={isHiddenOrCustomPlan}
            />
            </div>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}>
              {
                isShowingFeatures ? (
                  <button className='btn btn-outline-primary' style={{ margin: '0 auto' }} onClick={handleToggleFeatureList}> 
                    <i className="material-icons">remove</i>
                    Close features 
                  </button>
            
                ) : 
                <button className='btn btn-outline-primary' style={{ margin: '0 auto' }} onClick={handleToggleFeatureList}> 
                  <i className="material-icons">add</i>
                  Full list of features 
                </button>
                }
              {
                isShowingFeatures && 
                <div style={{ margin: '0 auto', marginTop: 10 }}>
                  <Features 
                    plans={viewablePlans}
                  />
                </div>
              }
            </div>
          </div>
          <div className="plan-clarification">
            <span>* For your information, all our pricing is denominated in U.S. Dollars (USD).</span>
            <br/>
            <span>* Please be aware that for certain countries, additional Goods and Services Tax (GST) may be applied in accordance with governmental regulations.</span>
          </div>
        </div>
        <GlobalFooter/>
      </div>
    </>
  )
}

export default NewPlans;